import { createSelector } from 'reselect';
import { CLIENT_STATE } from './HealthCareChartReducer';

export const clientId = (state, props) => props.clientId;

export const healthCareChartReducer = state => state.HealthCareChartReducer;

export const healthCareChartData = createSelector(
  clientId,
  healthCareChartReducer,
  (currentClient, reducer) => reducer[currentClient] || CLIENT_STATE,
);

export const isPrint = (state, props) => (
  props.isPrint || healthCareChartData(state, props).isPrint
);

export const hasLoaded = (state, props) => (
  props.loaded || healthCareChartData(state, props).loaded
);

export const isPdf = (state, props) => (
  props.isPdf || healthCareChartData(state, props).isPdf
);

export const goalId = (state, props) => (
  props.goalId || healthCareChartData(state, props).goalId
);

export const currentGoalId = (state, props) => (
  healthCareChartData(state, props).currentGoalId
);

export const fpId = (state, props) => (
  props.fpId || healthCareChartData(state, props).fpId
);

export const goalChartSettings = (state, props) => (
  healthCareChartData(state, props).chartSettings
);

export const goalBarChartSettings = (state, props) => (
  healthCareChartData(state, props).barChartSettings
);

export const goalChartData = (state, props) => (
  props.Data || healthCareChartData(state, props).data
);

export const chartCategories = (state, props) => (
  goalChartData(state, props).Categories
);

export const expensesSeries = (state, props) => (
  goalChartData(state, props).Series.Expenses
);

export const coveredSeries = (state, props) => (
  goalChartData(state, props).Series.Covered
);

export const currentSeries = (state, props) => (
  goalChartData(state, props).Series.Current
);

export const recommendedSeries = (state, props) => (
  goalChartData(state, props).Series.Recommended
);

export const dataIsOutdated = (state, props) => {
  const hasCurrentData = hasLoaded(state, props);
  const hasGoalId = goalId(state, props).length >= 0;
  const sameGoalId = goalId(state, props) === currentGoalId(state, props);
  return hasGoalId && hasCurrentData && !sameGoalId;
};

export const chartTitle = (state, props) => (
  props.chartTitle || goalChartData(state, props).title
);

export const getGoalChart = createSelector(
  goalChartSettings,
  goalBarChartSettings,
  currentSeries,
  recommendedSeries,
  (
    defaultChart,
    barChart,
    current,
    recommended,
  ) => {
    if (current >= 0 && recommended >= 0) {
      return barChart;
    }
    return defaultChart;
  },
);

export const goalChartPopulated = createSelector(
  isPrint,
  getGoalChart,
  chartCategories,
  expensesSeries,
  coveredSeries,
  currentSeries,
  recommendedSeries,
  (
    print,
    goalChart,
    categories,
    expenses,
    covered,
    current,
    recommended,
  ) => {
    const seriesWithData = goalChart.series.map((serie, index) => {
      if (index === 0) {
        return {
          ...serie,
          data: expenses || [recommended],
          animation: !print,
          color: !print ? serie.color : '#e5f8ff',
        };
      }
      return {
        ...serie,
        data: covered || [current],
        animation: !print,
      };
    });

    return {
      ...goalChart,
      xAxis: {
        ...goalChart.xAxis,
        categories,
      },
      series: seriesWithData,
    };
  },
);
